import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Guide = ({ content }) => {
    const guideImageList = content?.map?.((item) => item.imageUrl) || [];
    const [imagesHeight, setImagesHeight] = useState([0, 0, 0]);
    const [imagesOpacity, setimagesOpacity] = useState(0);
    const [guideTop, setguideTop] = useState(0);
    const image1Ref = useRef(null);
    const image2Ref = useRef(null);
    const image3Ref = useRef(null);
    const windowHeight = window.innerHeight;

    const loadAllImage = (imageDom) => {
        return new Promise((resolve, reject) => {
            if (imageDom.complete) {
                resolve(imageDom.src);
            } else {
                imageDom.onload = () => {
                    resolve(imageDom.src);
                };
                imageDom.onerror = () => reject(new Error('Image failed to load'));
            }
        });
    };

    // 翻页动画
    const pageTrunAction = () => {
        if (image1Ref.current.ontransitionend) {
            image1Ref.current.addEventListener(
                'transitionend',
                () => {
                    setguideTop(windowHeight);
                },
                false
            );
        } else {
            setTimeout(() => {
                setguideTop(windowHeight);
            }, 2000);
        }
    };

    // 执行胶片动画
    const imageTrunAction = () => {
        const imagesDom = [image1Ref.current, image2Ref.current, image3Ref.current];

        const promises = imagesDom.map((imageDom) => loadAllImage(imageDom));
        const promiseChain = Promise.all(promises);

        // 图片加载我完毕执行动画
        promiseChain
            .then(() => {
                setimagesOpacity(1);
                setImagesHeight([image1Ref.current.height - windowHeight, image2Ref.current.height - windowHeight, image3Ref.current.height - windowHeight]);
                pageTrunAction();
            })
            .catch((error) => {
                console.error('One or more images failed to load:', error);
            });
    };

    useEffect(() => {
        if (guideImageList?.length !== 3) {
            return false;
        }
        imageTrunAction();
    }, []);

    return guideImageList?.length === 3 ? (
        <div className={styles.guide} style={{ top: `-${guideTop}px` }}>
            <div className={`${styles.guideItem}`} style={{ opacity: imagesOpacity }}>
                <img ref={image1Ref} src={guideImageList[0]} className={styles.guideImage1} style={{ top: `-${imagesHeight[0]}px` }} />
            </div>
            <div className={`${styles.guideItem}`} style={{ opacity: imagesOpacity }}>
                <img ref={image2Ref} src={guideImageList[1]} className={styles.guideImage2} style={{ bottom: `-${imagesHeight[1]}px` }} />
            </div>
            <div className={`${styles.guideItem}`} style={{ opacity: imagesOpacity }}>
                <img ref={image3Ref} src={guideImageList[2]} className={styles.guideImage3} style={{ top: `-${imagesHeight[2]}px` }} />
            </div>
        </div>
    ) : null;
};

Guide.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Guide);
